import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsNumber } from "class-validator";

@Exclude()
export class AcceptanceRateInfo {
    @IsDefined()
    @Expose()
    public rate: number | null;

    @IsNumber()
    @Expose()
    public assignationsAccepted: number = 0;

    @IsNumber()
    @Expose()
    public assignationsDeclined: number = 0;
}
